import { financeAPI } from "../../axios";
export const actions = {
    createNewFee(context, data){
        return financeAPI.post(`Fee/Create/${data.campusId}`, data)
    },
    getSingleFee(context, feeId){
        return financeAPI.get(`Fee/${feeId}`)
    },
    getFeesByCampus(context, data){
        return financeAPI.get(`Fee/Campus/${data}`)
    },
    getFeesByFundSource(context, data){
        return financeAPI.get(`Fee/FundSource/${data}`)
    },
    updateFee(context, data){
        return financeAPI.put(`Fee/Update/${data.id}`, data)
    },
    deleteFee(context, feeId){
        return financeAPI.delete(`Fee/Delete/${feeId}`)
    }
}
export const getters = {}